/**
 * FT10-U16: Supplier Statement (FSD 2.2.2, FIN-F02 reports). The INT packet spreads
 * `AP_SUPPLIER_STATEMENT_ROUTES` and adds nav item `ap-supplier-statement` (p02).
 * The route's permission is the report endpoint's: `ap.report.read`.
 */

import type { RouteRecordRaw } from 'vue-router'

import { SUPPLIER_STATEMENT_PERMISSIONS } from './api'

export const AP_SUPPLIER_STATEMENT_ROUTES: RouteRecordRaw[] = [
  {
    path: '/ap/reports/supplier-statement',
    name: 'ap-supplier-statement',
    component: () => import('@/modules/ap/reports/supplier-statement/SupplierStatementView.vue'),
    meta: {
      titleKey: 'ap.routeTitles.supplierStatement',
      permission: SUPPLIER_STATEMENT_PERMISSIONS.reportRead,
    },
  },
]
